<template>
	<div class="case-detail">
		<!-- header -->
		<!-- <div class="case-detail.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="case-detail.block">
			<intellectual-navigation :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="+navigation-line"></div>
		<!-- 面包屑 -->
		<div class="case-detail.bread">
			<Bread :currentPage="{name:'成功案例',path:'/Case',childName:'案例详情',childPath:$route.path}" />
		</div>
		<div class="case-detail.container">
			<div class="case-detail.box" data-aos="fade-up">
				<h2>{{caseDetail.name}}<small>来源：知识产权服务平台 时间：{{caseDetail.date_time}}</small></h2>
				
				<span><img :src="this.imgUrl + caseDetail.illustration_image"></span>
				<p>{{caseDetail.synopsis}}</p>
			</div>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import Bread from '../components/bread.vue'

	export default {
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			Bread,

		},
		data() {
			return {
				isTrademark: false,
				caseDetail:{}
			}
		},
		methods:{
			toggleTrademarks(val){
				this.isTrademark = val
			},
			initCaseData(){
				this.http.get(`IPR_Success/${this.$route.params.id}`).then(res => {
					console.log(res)
					this.caseDetail = res.data
				})
			}
		},
		mounted(){
			window.scrollTo(0,0);
			this.initCaseData()
		}
	}
</script>

<style lang="scss">
	@include component(case-detail) {
		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			background: #fff;
		}

		@include part(bread) {
			width: 100%;
			min-width: $minWidth;
			height: 51px;
			background: #fff;
		}

		@include part(container) {
			width: 100%;
			background: #F7F7F7;
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;

		}

		@include part(box) {
			width: 1200px;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
			margin: 0 auto;
			margin-top: 21px;
			color: #333333;
			padding: 60px 121px;

			>h2 {
				margin: 0;
				font-size: 24px;
				font-weight: bold;
				border-bottom: 1px solid #F2F2F2;
				padding-bottom: 29px;

				small {
					display: block;
					color: #999999;
					font-size: 16px;
					margin-top: 20px;
				}
			}

			>p {
				text-align: left;
				line-height: 30px;
				text-indent: 20px;
				margin-top: 40px;
			}
            >span{
				margin-top: 40px;
				display: block;
				text-align: center;
				width: 100%;
				img{
					width: 100%;
					display: block;
				}
			}
			>ul {
				margin-top: 119px;
				width: 100%;
				display: flex;
				flex-direction: column;
				align-items: flex-start;

				li {
					margin-bottom: 10px;

					a {
						color: #333333;
					}
				}
			}

		}

	}
</style>
